import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';


export const CloseIcon = memo(({ width=18, height=18, strokeColor='#FFFFFF', fillColor='#FFFFFF' }) => {
    return (
        <OuterSvg
            width={width}
            height={height}
            stroke={strokeColor}
            fill={fillColor}
            viewBox='0 0 9.9 5.1'
        >
            <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
                viewBox='0 0 12.7 12.7' enableBackground='new 0 0 12.7 12.7' space='preserve'>
                <path fillRule='evenodd' clipRule='evenodd' d='M0.3,11.2c-0.3,0.3-0.3,0.9,0,1.2l0,0c0.3,0.3,0.9,0.3,1.2,0l11-11
                c0.3-0.3,0.3-0.9,0-1.2l0,0c-0.3-0.3-0.9-0.3-1.2,0L0.3,11.2L0.3,11.2z M0.3,11.2'/>
                <path fillRule='evenodd' clipRule='evenodd' d='M12.5,11.2c0.3,0.3,0.3,0.9,0,1.2l0,0c-0.3,0.3-0.9,0.3-1.2,0l-11-11
                c-0.3-0.3-0.3-0.9,0-1.2l0,0c0.3-0.3,0.9-0.3,1.2,0L12.5,11.2L12.5,11.2z M12.5,11.2'/>
            </svg>
        </OuterSvg>
    );

});

CloseIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    strokeColor: PropTypes.string,
    fillColor: PropTypes.string
};

CloseIcon.displayName = 'CloseIcon';

const OuterSvg = styled.svg`
    transition: all 0.25s ease-out;
`;
